module.exports = __webpack_public_path__ + "static/img/game-logo-sa.3264511.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-sa.png
// module id = B1o0
// module chunks = 0 1 2 3 4 5 6